import portrait from "../images/profile2.png";

const STATS = [
  { v: "3+", l: "Years building" },
  { v: "6", l: "Languages" },
  { v: "12", l: "Repos shipped" },
  { v: "∞", l: "Curiosity" },
];

function About() {
  return (
    <section className="section" id="about">
      <div className="wrap">
        <div className="section-head reveal">
          <h2 className="section-title">About</h2>
          <p className="section-note">
            The short version — who I am and how I work.
          </p>
        </div>
        <div className="about-grid">
          <div className="about-portrait reveal">
            <img src={portrait} alt="Abdul Basit Iqbal" />
          </div>
          <div className="about-body reveal" data-d="1">
            <p className="lead">
              I'm a full-stack software engineer who cares as much about{" "}
              <em>how</em> something is built as <em>what</em> it does.
            </p>
            <p>
              Over the past 3+ years I've built modern, scalable web applications
              end-to-end — working across the <strong>MERN stack</strong>,{" "}
              <strong>Next.js</strong> and <strong>Angular</strong> on the front, and{" "}
              <strong>Node.js</strong> and <strong>Laravel</strong> on the back. I'm
              fluent in JavaScript and TypeScript, and comfortable reaching for Python,
              PHP or Rust when the problem calls for it.
            </p>
            <p>
              I work hands-on with <strong>Claude Code</strong>, prompt engineering and
              AI-assisted development — shipping an AI-powered web builder, and leaning
              on those workflows to contribute Rust microservices outside my core stack.
            </p>
            <p>
              I'm a strong problem solver who adapts quickly to new stacks and domains. I
              keep my fundamentals sharp with regular DSA practice, and I'm always open to
              freelance, full-time and open-source collaboration.
            </p>
            <p>
              <strong>BS in Computer Science</strong> — Institute of Management Sciences
              (IMSciences), Peshawar · 2020–2024
            </p>
            <div className="stats">
              {STATS.map((s) => (
                <div className="stat" key={s.l}>
                  <div className="v">{s.v}</div>
                  <div className="l">{s.l}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
